import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=1a2e0dd8&scoped=true&"
import script from "./RoleUserList.vue?vue&type=script&lang=js&"
export * from "./RoleUserList.vue?vue&type=script&lang=js&"
import style0 from "./RoleUserList.vue?vue&type=style&index=0&id=1a2e0dd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2e0dd8",
  null
  
)

export default component.exports